import type { GameController } from '../../core/GameController';
import { GAME_TITLE } from '../../core/constants';
import type { GameSnapshot } from '../../core/types';
import { ActionButton, BrandMark, MenuFrame } from '../components/MenuFrame';

export function SplashScreen({ controller }: { controller: GameController }) {
  return (
    <section className="splash-screen screen-layer" onClick={() => controller.dismissSplash()}>
      <div className="splash-screen__speed-lines" aria-hidden="true" />
      <div className="splash-screen__logo">
        <BrandMark />
        <p>Forgeworks Interactive presents</p>
        <h1>{GAME_TITLE}</h1>
        <span>Pure speed. Perfect line.</span>
      </div>
      <button className="splash-screen__continue" onClick={() => controller.dismissSplash()}>
        Press any key to continue
      </button>
    </section>
  );
}

export function MainMenu({ controller, snapshot }: { controller: GameController; snapshot: GameSnapshot }) {
  const desktop = Boolean(window.desktop?.isElectron);
  return (
    <div className="main-menu screen-layer screen-layer--left">
      <div className="main-menu__brand">
        <BrandMark />
        <p>Arcade time trial</p>
        <h1>{GAME_TITLE}</h1>
        <span>Build speed. Break records.</span>
      </div>
      <nav className="main-menu__actions" aria-label="Main menu">
        <ActionButton
          autoFocus
          variant="primary"
          icon="▶"
          label="Play"
          detail="Choose a course and chase your best"
          onClick={() => controller.startPlayFlow()}
        />
        <ActionButton icon="⌁" label="Track Select" detail="Six handcrafted challenges" onClick={() => controller.openTrackSelect()} />
        <ActionButton icon="◇" label="Car Select" detail={`Current: ${snapshot.selectedCarId.toUpperCase()}`} onClick={() => controller.openCarSelect()} />
        <ActionButton icon="⚙" label="Settings" detail="Video, audio, gameplay & controls" onClick={() => controller.openSettings()} />
        <ActionButton icon="×" label="Quit" detail={desktop ? 'Return to Windows' : 'Close the game tab'} variant="quiet" onClick={() => controller.quit()} />
      </nav>
      <div className="main-menu__footer">
        <span>WASD / ARROWS</span>
        <i />
        <span>SPACE HANDBRAKE</span>
        <i />
        <span>R INSTANT RESTART</span>
      </div>
    </div>
  );
}
